import React, {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
// import { useHistory } from "react-router-dom";
import { getMoengage } from "../../utils/moengage.js";
import { useLocation, useNavigate } from "react-router-dom";
// import Info from '../../../components/advance/Info';
import Modal from "../../components/advance/Modal";
import Button from "../../components/core/EPL_Button_Think";
import CheckField from "../../components/form/CheckField";
import LoanSummaryTextItem from "../loan-agreement/_styles/EPL_LoanSummaryTextItem";
import Text from "../loan-agreement/_styles/EPL_Text.js";
// import CheckField from '../../../components/form/CheckField';
import useMediaQuery from "../../hooks/useMediaQuery";
import { ConstantContext } from "../../shared/context/ConstantContext";
// import VendorService from "../../shared/services/VendorService";
import appendRupee from "../../utils/appendRupee";
import sendRequest from "../../utils/sendRequest";
// import Progress from "../progress/Progress";
// import Summary from "../summary/Summary";
import { LoanIPOWrapper } from "./_styles/LoanIPOWrapper";
// import ProgressBar from "../../components/navigation/progress_bar/ProgressBar.js";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
// import graphic from "../../assets/svg/EPL_think_svg/IncomeVerifaction.svg";
// import iconCoins from "../../assets/svg/EPL_think_svg/Icon_Coins.svg";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import { encrypt } from "../../utils/crypto.js";
// import almostThere from "../../assets/svg/EPL_think_svg/Ipo_ALmostThere.svg";
import {
  GetCustomerDetailsContext,
  GetCustomerDetails,
  validateInputExistenece,
} from "../../App.js";
import { INSERT_IPO, REVIEW_IPO } from "../../Config.js";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService.js";
import ScenarioBasedBottomModal from "../other-pages/Modals/ScenarioBasedBottomModal";
import { updateLead } from "../../shared/services/crm";
import { CheckInternetModal } from "../other-pages/Modals/AllModal";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import { userConsentStatus } from "../../utils/userConsentStatus.js";
import { encryptedData } from "../../utils/index.js";

const LoanIPO = () => {
  const moengage = getMoengage();
  // // console.log("\n\nINSIDE LoanIPO\n\n");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const history = useHistory();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");

  const { constant } = useContext(ConstantContext);
  const [totalLoanAmount, setTotalLoanAmount] = useState(Number(170000));
  const [processingFees, setProcessingFees] = useState("0000");
  const [maxEmi, setMaxEmi] = useState("00000");
  const [emi, setEmi] = useState("00000");
  const [maxTopUpAmount, setMaxTopUpAmount] = useState("500000");
  const [minTopUpAmount, setMinTopUpAmount] = useState("100000");
  const [ischecked, setIsChecked] = useState(false);
  const [lastTenure, setLastTenure] = useState(0);
  const [processing_fee_rate, set_processing_fee_rate] = useState();
  const [tenureOptions, setTenureOptions] = useState([]);
  const [showFeeAndChargesModal, setShowFeeAndChargesModal] = useState();
  const [totalLoanAmountForUpsell, setTotalLoanAmountForUpsell] = useState();

  const [tenure, setTenure] = useState();
  const [interestRate, setInterestRate] = useState(0);
  const [maxApprovedLoanAmount, setMaxApprovedLoanAmount] = useState(0); // constant.MAX_LOAN_AMT.value);
  const insuranceAmount = 1500;
  const [approvedRoi, setApprovedRoi] = useState(0);
  const [maxTenure, setMaxTenure] = useState(0); // constant.MAX_TENURE.value);
  const minLoanIPOAmount = Number(20); // constant.MIN_LOAN_AMT.value);
  const minProcessingFee = Number(200); // constant.MIN_PROCESSING_FEE.value);
  const [minTenure, setMinTenure] = useState(0); // constant.MIN_TENURE.value);
  const processingFeeROI = Number(10); // constant.ROI_PROCESSING_FEE.value);
  const [selectedLoanAmount, setSelectedLoanAmount] = useState(0);
  const [editableContent, setEditableContent] = useState(0);
  const [approvedLoanAmount, setApprovedLoanAmount] = useState(0);
  const [modal, setModal] = useState("");
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(false);
  const [lastSelectedLoanAmount, setLastSelectedLoanAmount] = useState(0);
  const [fetchData, setFetchedData] = useState(false);
  const [maxApprovedEMIAmount, setMaxApprovedEMIAmount] = useState(0);
  const [oldLoanAccountNumber, setOldLoanAccountNumber] = useState();
  const [internetCheck, setInternetCheck] = useState(false);
  const [processingFee, setProcessingFee] = useState(0);
  const [existingLoanBalance, setExistingLoanBalance] = useState(0);
  const [dataCaptured, setDataCaptured] = useState();
  const [showBottomModal, setShowBottomModal] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(false);
  const [requiredHigherLoanAmount, setRequiredHigherLoanAmount] = useState(false);
  const [offerAgreementConsent, setOfferAgreementConsent] = useState(false);
  
  const updateRequiredHigherLoanAmount = (e) => { 
    if (e.target.value === "Yes") {
      setRequiredHigherLoanAmount(true);
    }
    else { 
      setRequiredHigherLoanAmount(false);
    }
  }

  let applicationFormNumber = customerDetails?.application_form_number;

  const reducerLoanIPOValues = (state, action) => {
    if (action.emiAmount > maxApprovedEMIAmount) {
      return state;
    } else {
      const processing_fee = Math.round(
        Number.parseFloat(processingFeeROI / 100) * action.loanAmount
      );
      if (processing_fee < minProcessingFee) {
        setProcessingFee(minProcessingFee);
      } else {
        setProcessingFee(processing_fee);
      }
      return action;
    }
  };

  const getAllTenures = (min, max) => {
    let arr = [];
    if (min !== 0 && max !== 0) {
      var minTen = min;
      var maxTen = max;

      if (minTen < 12) {
        minTen = 12;
      }
      if (minTen > 60) {
        minTen = 60;
      }
      if (maxTen > 60) {
        maxTen = 60;
      }
      if (minTen % 12 !== 0 && minTen !== 0) {
        arr.push(minTen);
        minTen = minTen + (12 - (minTen % 12));
      }
      for (let t = minTen; t <= maxTen; t += 12) {
        arr.push(t);
      }
      if (arr[arr.length - 1] !== maxTen) {
        arr.push(maxTen);
      }
    }
    return arr;
  };

  const calculateProcessingFees = (processingFee) => {
    if (
      customerDetails.source === "upsell" ||
      customerDetails?.Data.journey_type === "preapproved"
    ) {
      setProcessingFees((parseFloat(processingFee) / 100) * selectedLoanAmount);
    } else {
      if (customerDetails?.Data.employer_cat === "ABG") {
        setProcessingFees(0);
      } else {
        // if (parseInt(selectedLoanAmount) < 500000) {
        //   setProcessingFees((parseFloat(2.36) / 100) * selectedLoanAmount);
        // } else if (parseInt(selectedLoanAmount) >= 500000) {
        //   setProcessingFees((parseFloat(2.36) / 100) * selectedLoanAmount);
        // }
        setProcessingFees(
          ((parseFloat(processingFee) / 100) * selectedLoanAmount).toFixed(2)
        );
      }
    }
  };

  useEffect(() => {
    

    isStageLogin(    
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
  }, [])

  // const calculateRoi = ({ selectedAmount = selectedLoanAmount }) => {
  //   if (selectedAmount !== "000000") {
  //     if (selectedAmount < 200000) {
  //       setApprovedRoi(13.0);
  //     } else if (selectedAmount >= 200000 && selectedAmount <= 399000) {
  //       setApprovedRoi(12.0);
  //     } else if (selectedAmount >= 400000 && selectedAmount <= 699000) {
  //       setApprovedRoi(11.5);
  //     } else if (selectedAmount >= 700000 && selectedAmount <= 999000) {
  //       setApprovedRoi(11.25);
  //     } else if (selectedAmount >= 1000000 && selectedAmount <= 1499000) {
  //       setApprovedRoi(10.99);
  //     } else {
  //       setApprovedRoi(10.55);
  //     }

  //     // // console.log("****** 1", { selectedAmount, approvedRoi });
  //   }
  //   // // console.log("****** 2", { selectedAmount, approvedRoi });
  // };

  const [loanIPOValues, dispatchLoanIPOValues] = useReducer(
    reducerLoanIPOValues,
    {
      emiAmount: 1000,
      loanAmount: 1000000,
      tenure: 36,
    }
  );

  const handleTenureChange = (event) => {
    // // console.log("clicked");
    setLastTenure(tenure);
    // console.log("@@@@@@@@@@@@@@ event.target.value: ", event.target.value);
    setTenure(parseFloat(event.target.value));
  };

  const setProgress = (
    selectedAmount,
    { min = minTopUpAmount, max = maxTopUpAmount }
  ) => {
    // // console.log("In setProgress");
    // // console.log("\tselectedAmount: ", selectedAmount);
    // // console.log("\tminTopUpAmount: ", min);
    // // console.log("\tmaxTopUpAmount: ", max);
    const rng = document.querySelector("#selectedAmountRange");
    // var errorMargin = 1 - (maxTopUpAmount / (maxTopUpAmount - minTopUpAmount));
    // let percent = Math.round((selectedAmount / (maxTopUpAmount - minTopUpAmount) + errorMargin) * 100 );
    // // // console.log("Slider errorMargin", errorMargin);
    // Above commented is long expression, below is resolved
    let percent = Math.round(((selectedAmount - min) / (max - min)) * 100);
    // // console.log("\tSLIDER selectedAmount: ", selectedAmount);
    // // console.log("\tSLIDER minTopUpAmount: ", min);
    // // console.log("\tSLIDER maxTopUpAmount: ", max);
    // // console.log("\tSLIDER: ", percent);
    if (percent === Infinity) {
      percent = 100;
    }
    // else {
    //   percent -= 25;
    // }

    rng.style.backgroundImage = `linear-gradient(to right, #C7222A 0%, #C7222A ${percent}%, #EBEBEB ${percent}%, #EBEBEB 100%)`;
    // // console.log("Out setProgress");
  };

  var debounce;
  const validChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", null];
  const inputLoanAmount = (event) => {
    if (!validChars.includes(event.nativeEvent.data)) {
      event.preventDefault();
      setEditableContent(selectedLoanAmount);
      document.getElementById("editableContent").innerHTML =
        parseInt(selectedLoanAmount).toLocaleString("en-IN");
      return;
    }
    if (debounce) {
      clearTimeout(debounce);
    }
    debounce = setTimeout(() => {
      var current_amount = event.target.innerText;
      current_amount = current_amount.replace(/,/g, "");
      const amount = parseInt(current_amount);
      // console.log(amount, ">>>>>>>>>>>>>>>>>>>>>>>", minTopUpAmount);
      if (amount >= minTopUpAmount && amount <= maxTopUpAmount) {
        setLastSelectedLoanAmount(selectedLoanAmount);
        setSelectedLoanAmount(amount);
        setProgress(amount, { min: minTopUpAmount, max: maxTopUpAmount });
      } else {
        if (amount < minTopUpAmount) {
          // console.log("changed to minimum");
          setSelectedLoanAmount(minTopUpAmount);
          setLastSelectedLoanAmount(minTopUpAmount);
          setProgress(minTopUpAmount, {
            min: minTopUpAmount,
            max: maxTopUpAmount,
          });
          document.getElementById("editableContent").innerHTML =
            parseInt(minTopUpAmount).toLocaleString("en-IN");
        } else if (amount > maxTopUpAmount) {
          // console.log("changed to Max");
          setSelectedLoanAmount(maxTopUpAmount);
          setLastSelectedLoanAmount(maxTopUpAmount);
          setProgress(maxTopUpAmount, {
            min: minTopUpAmount,
            max: maxTopUpAmount,
          });
          document.getElementById("editableContent").innerHTML =
            parseInt(maxTopUpAmount).toLocaleString("en-IN");
        }
        // setSelectedLoanAmount(selectedLoanAmount);
        // setProgress(selectedLoanAmount, { min: minTopUpAmount, max: maxTopUpAmount });
        // setEditableContent(selectedLoanAmount);
      }
    }, 1000);
  };

  const handleLoanAmountChange = (event) => {
    // // console.log("changed");
    // // console.log("event: ", event);
    // // console.log("e.target.value: ", event.target.value);
    // // console.log("e.target.innerText: ", event.target.innerText);
    setLastSelectedLoanAmount(selectedLoanAmount);
    // var current_amount = [undefined, null, "None"].includes(event.target.value) ? event.target.innerText : event.target.value;
    var current_amount = event.target.value;
    const amount = parseInt(current_amount);
    setSelectedLoanAmount(amount);
    // // console.log("minTopUpAmount: ", minTopUpAmount);
    // // console.log("maxTopUpAmount: ", maxTopUpAmount);
    setProgress(amount, { min: minTopUpAmount, max: maxTopUpAmount });
  };

  const handleCheckBox = async () => {
    setOfferAgreementConsent(!offerAgreementConsent);
    setIsChecked(!ischecked);
    // // console.log("checkBox clicked");
  };

  const isValidForm = useCallback(() => {
    return (
      loanIPOValues.loanAmount >= minLoanIPOAmount &&
      loanIPOValues.loanAmount <= maxApprovedLoanAmount &&
      loanIPOValues.tenure % minTenure === 0 &&
      loanIPOValues.tenure >= minTenure &&
      loanIPOValues.tenure <= maxTenure &&
      loanIPOValues.emiAmount <= maxApprovedEMIAmount
    );
  }, [
    maxApprovedEMIAmount,
    loanIPOValues.emiAmount,
    loanIPOValues.loanAmount,
    loanIPOValues.tenure,
    maxApprovedLoanAmount,
    maxTenure,
    minLoanIPOAmount,
    minTenure,
  ]);

  const handleProceedClick = async()=>{
    const payload = {
      ipo_agreement_to_offer: offerAgreementConsent,
    }
    const src = customerDetails?.source;

    await userConsentStatus(payload , src);
    await onProceed();
  }

  const onProceed = async () => {
    if(customerDetails?.Data?.lob || customerDetails?.Data?.offer_type?.startsWith("ABCDPA")){
      if (window.fbq) {
        window.fbq("track", "IPO", { value: 0.0, currency: "USD" });
      } 
      if (window.gtag_report_conversion) {
        window.gtag_report_conversion();
      } 
    }
    moengage?.track_event("LoanIPO", {
      journey_name: customerDetails.source,
      "loanAmount": selectedLoanAmount, // string value
      "tenure": tenure, // numeric value
      });

    moengage?.add_user_attribute("Loan_Amount", selectedLoanAmount);
    // console.log("tempo tomerDetails?.stage: ", customerDetails?.stage);
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"]) &&
      customerDetails?.stage === "REVIEW_IPO_START"
    ) {
      await updateLoanIPODetails();
    } else {
      await insertIPODetails();
    }
  };

  const insertIPODetails = async () => {
    // console.log(customerDetails);
    try {
      const formData = new FormData();
      if (customerDetails.source === "upsell") {
        const requestData = {
          cust_accepted_loan_amount: selectedLoanAmount.toString(),
          roi: approvedRoi.toString(),
          processing_fees: processingFees.toString(),
          cust_accepted_emi: emi.toString(),
          loan_tenure: tenure.toString(),
          current_stage: customerDetails.stage,
        };
        formData.append("data", encryptedData(requestData));
      } else {
        const requestData = {
          cust_accepted_loan_amount: selectedLoanAmount.toString(),
          roi: approvedRoi.toString(),
          processing_fees: processingFees.toString(),
          cust_accepted_emi: emi.toString(),
          loan_tenure: tenure.toString(),
          current_stage: customerDetails.stage,
          requiredHigherLoanAmount: requiredHigherLoanAmount,
        };
        formData.append("data", encryptedData(requestData));
        // console.log("IN_INSERT_IPO: ", INSERT_IPO, "\nPayload: ", requestData);
      }
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + INSERT_IPO,
          formData
        );
        setShowShimmer(false);
        // // console.log("INSERT_IPO response: ", response);
        if (response.response.Success === true) {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              52,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              52,
              customerDetails.application_form_number
            );
          }
          // // console.log(response.response.STAGE);
          // // console.log("insertIPODetails setCustomerDetails-1");
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE,
          });
        } else {
          if (response.response.Message == "SUCCESS_REJECTED") {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "PAN_ESSENTIALS_REJECT",
            });
            // // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }
          console.error(`EMI Check Failed!`);
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              65,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              65,
              customerDetails.application_form_number
            );
          }
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
        console.error(`Unknown Error: ${error}`);
        setShowShimmer(false);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          65,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          65,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      // // console.log(error);
    }
  };

  const updateLoanIPODetails = async () => {
    try {
      const formData = new FormData();
      const requestData = {
        cust_accepted_loan_amount: selectedLoanAmount.toString(),
        roi: approvedRoi.toString(),
        processing_fees: processingFees.toString(),
        cust_accepted_emi: emi.toString(),
        loan_tenure: tenure.toString(),
        current_stage: customerDetails.stage,
      };
      formData.append("data", encryptedData(requestData));
      // console.log("IN_REVIEW_IPO: ", REVIEW_IPO, "\nPayload: ", requestData);
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + REVIEW_IPO,
          formData
        );
        setShowShimmer(false);
        // // console.log("In_REVIEW_IPO response: ", response);
        if (response.response.Success === true) {
          // console.log(response.response.STAGE);
          // console.log(response.response);
          // console.log("updateLoanIPODetails setCustomerDetails-2");
          // setCustomerDetails({
          //   ...customerDetails,
          //   stage: response.response.STAGE,
          // });
          const updated = customerDetails;
          updated.stage = response.response.STAGE;
          setCustomerDetails({
            ...updated,
          });
        } else {
          console.error(`EMI Check Failed!`);
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              74,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              74,
              customerDetails.application_form_number
            );
          }
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
        setShowShimmer(false);
        console.error(`Unknown Error: ${error}`);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          74,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          74,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      // // console.log(error);
    }
  };

  useEffect(async () => {
    // // console.log("USEEFFECT-customerDetails-1: Rerouting");
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails.full_name)
    ) {
      // // console.log("\tLoanIPO customerDetails: ", customerDetails);
      applicationFormNumber = customerDetails?.application_form_number;
      setShowShimmer(false);
      // TODO: Handle Staging if needed
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++");
      // console.log("Sending below customerDetails from LoanIPO: ");
      // console.log(customerDetails);
      // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++");
      // // console.log("\tstage: ", customerDetails.stage);
      // // console.log("\troute: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    }
  }, [customerDetails]);

  // useEffect(async () => {
  //   // window.scrollTo(0, 0);
  //   // console.log("USEEFFECT-NoDependency: getCustomerDetails");
  //   await GetCustomerDetails(
  //     customerDetails.application_form_number,
  //     customerDetails.source,
  //     customerDetails,
  //     setCustomerDetails
  //   );
  //   setDataCaptured(true);
  //   // var getCustomerDetails = async () => {
  //   //   await GetCustomerDetails(
  //   //     customerDetails.application_form_number,
  //   //     customerDetails.source,
  //   //     customerDetails,
  //   //     setCustomerDetails
  //   //   );
  //   //   setDataCaptured(true);
  //   // }
  //   // getCustomerDetails();
  // }, []);

  useEffect(() => {
    // console.log("***** UPDATING VALUES *****");
    // console.log("LOADED ---> LoanIPO ", customerDetails);
    if (customerDetails.source === "upsell") {
      var init_existing_amount =
        parseInt(customerDetails?.Data?.old_loan_amount) || 0;
      setExistingLoanBalance(init_existing_amount);
      setOldLoanAccountNumber(customerDetails?.Data?.old_loan_account_number);
      setTotalLoanAmountForUpsell(
        customerDetails?.Data?.old_loan_amount +
          customerDetails?.Data?.max_topup
      );
    }
    // // console.log("USEEFFECT-customerDetails-2: Setting Variables");
    // // console.log("\tcustomerDetails?.Data?.cust_accepted_loan_amount: ", customerDetails?.Data?.cust_accepted_loan_amount);
    // // console.log("\tcustomerDetails?.Data?.cust_accepted_emi: ", customerDetails?.Data?.cust_accepted_emi);
    setMaxEmi(parseInt(customerDetails?.Data?.max_emi) || 0);
    // setEmi(parseInt(customerDetails?.Data?.cust_accepted_emi) || 0);
    setMinTopUpAmount(parseInt(customerDetails?.Data?.min_topup) || 0);
    setMaxTopUpAmount(parseInt(customerDetails?.Data?.max_topup) || 0);
    setMinTenure(parseInt(customerDetails?.Data?.min_tenure) || 12);
    setMaxTenure(parseInt(customerDetails?.Data?.max_tenure) || 60);
    setApprovedRoi(customerDetails?.Data?.roi || 0);
    var init_amount =
      customerDetails?.Data?.cust_accepted_loan_amount === "None"
        ? parseInt(customerDetails?.Data?.max_topup)
        : parseInt(customerDetails?.Data?.cust_accepted_loan_amount);
    var init_tenure =
      customerDetails?.Data?.tenure === "None"
        ? parseInt(customerDetails?.Data?.max_tenure)
        : parseInt(customerDetails?.Data?.tenure);
    setSelectedLoanAmount(init_amount || 0);
    setTenure(init_tenure);
    // console.log(init_tenure);
    // console.log(tenure);
    set_processing_fee_rate(customerDetails?.Data?.processing_fees);
    setLastSelectedLoanAmount(init_amount || 0);
    setApprovedLoanAmount(parseInt(customerDetails?.Data?.max_topup) || 0);
    if(customerDetails?.stage === "IPO_START"){
      moengage?.track_event("Offer_generation", {
        offered_loan_amount: customerDetails?.Data?.max_topup? customerDetails?.Data?.max_topup : 0,
        "journey name": customerDetails.source,
      });
     }
    setProgress(init_amount || 0, {
      min: parseInt(customerDetails?.Data?.min_topup),
      max: parseInt(customerDetails?.Data?.max_topup),
    });
    calculateProcessingFees(customerDetails?.Data?.processing_fees);
    // calculateRoi({ selectedAmount: init_amount });
    setShowBottomModal(
      customerDetails?.stage === "REVIEW_IPO_START" ? false : true || true
    );
    // // console.log("Bottom Modal: ", customerDetails?.stage === "REVIEW_IPO_START" ? false : true || true);
    // console.log("***** UPDATED VALUES *****");
  }, [customerDetails]);

  // // // console.log("customerDetails: ", customerDetails);

  // useEffect(() => {
  //   // // console.log("USEEFFECT-dataCaptured");
  //   // window.scrollTo(0, 0);
  // }, [dataCaptured]);

  useEffect(() => {
    if (tenure > 60 && tenure !== 0) {
      setTenure(60);
    }
    if (tenure < 12 && tenure !== 0) {
      setTenure(12);
    }
    // console.log("TENURE CHANGING<<<<<<<.......>>>>", tenure);
  }, [tenure]);

  useEffect(() => {
    // // console.log("USEEFFECT-minTenure, maxTenure: setting Tenure Options / Tenure");
    setTenureOptions(getAllTenures(minTenure, maxTenure));
    var init_tenure =
      customerDetails?.Data?.tenure === "None" || 0
        ? parseInt(customerDetails?.Data?.max_tenure)
        : parseInt(customerDetails?.Data?.tenure);
    setTenure(init_tenure);
    // console.log(
    //   ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>------------------------------",
    //   tenure
    // );
  }, [minTenure, maxTenure]);

  useEffect(() => {
    calculateProcessingFees(processing_fee_rate);
    // console.log("====================================");
    // console.log("Calculating Tenure with maxEmi: ", maxEmi);
    var current_total_loan_amount = selectedLoanAmount + existingLoanBalance;
    // // console.log("USEEFFECT-selectedLoanAmount, maxEmi, maxTenure, approvedRoi: setting tenure options");
    let tenlist = [];
    var minTen = minTenure;
    var maxTen = maxTenure;
    if (minTen !== 0 && maxTen !== 0) {
      if (minTen < 12) {
        minTen = 12;
      }
      if (minTen > 60) {
        minTen = 60;
      }
      if (maxTenure > 60) {
        maxTen = 60;
      }
      if (minTen % 12 !== 0) {
        tenlist.push(minTen);
        minTen = minTen + (12 - (minTen % 12));
      }
      minTen = Math.min(minTen, maxTen);
      maxTen = Math.max(12, maxTen);
      for (let t = minTen; t <= maxTen; t += 12) {
        tenlist.push(t);
      }
      // console.log(tenlist[tenlist.length - 1]);
      if (tenlist[tenlist.length - 1] !== maxTen) {
        tenlist.push(maxTen);
      }
      let minSelected = true;
      tenlist.forEach((ten, index) => {
        if (minSelected === true) {
          let emiTemp;
          if (approvedRoi === 0) {
            emiTemp = current_total_loan_amount / ten;
          } else {
            let roi = approvedRoi / (12.0 * 100);
            emiTemp =
              (current_total_loan_amount * roi * Math.pow(1 + roi, ten)) /
              (Math.pow(1 + roi, ten) - 1);
          }
          // console.log("EMI", emiTemp);
          // console.log("\temiTemp: ", emiTemp, " for tenure: ", ten);
          if (emiTemp <= maxEmi) {
            minTen = ten;
            minSelected = false;
          }
        }
      });
    }
    setTenureOptions(getAllTenures(minTen, maxTen));
  }, [selectedLoanAmount]);

  useEffect(() => {
    if (tenureOptions.length !== 0 && tenureOptions.indexOf(tenure) === -1) {
      setTenure(tenureOptions[tenureOptions.length - 1]);
    }
  }, [tenureOptions]);

  useEffect(() => {
    var current_total_loan_amount = selectedLoanAmount + existingLoanBalance;
    // // console.log("USEEFFECT-tenure, approvedRoi, selectedLoanAmount: Setting EMI");
    let current_emi = emi;
    if (approvedRoi === 0) {
      current_emi = current_total_loan_amount / tenure;
      setEmi(Math.round(current_emi));
    } else {
      let roi = approvedRoi / (12.0 * 100);
      current_emi =
        (current_total_loan_amount * roi * Math.pow(1 + roi, tenure)) /
        (Math.pow(1 + roi, tenure) - 1);
      setEmi(Math.round(current_emi));
    }
    // console.log("Max-EMI: ", maxEmi);
    // console.log("EMI: ", current_emi);
  }, [tenure, approvedRoi, selectedLoanAmount]);

  // useEffect(() => {
  //   // // console.log("USEEFFECT-selectedLoanAmount, approvedRoi, processingFees, emi, tenure");
  //   // // console.log("\tsetting CustomerDetails-3");
  //   setCustomerDetails({
  //     ...customerDetails,
  //     loan_amount: selectedLoanAmount,
  //     interestRate: approvedRoi,
  //     processingFees: processingFees,
  //     emi: emi,
  //     tenure: tenure,
  //   });
  // }, [selectedLoanAmount, approvedRoi, processingFees, emi, tenure]);

  useEffect(() => {
    // console.log("In useEffect for editableContent: ", selectedLoanAmount);
    setEditableContent(selectedLoanAmount);
    document.getElementById("editableContent").innerHTML =
      parseInt(selectedLoanAmount).toLocaleString("en-IN");
  }, [selectedLoanAmount]);

  useEffect(() => {
    // // console.log("USEEFFECT-isValidForm: Button Enabling/Disabling");
    if (isValidForm()) {
      setOnSubmitButtonDisabled(false);
    } else {
      setOnSubmitButtonDisabled(true);
    }
  }, [isValidForm]);

  return (
    <>
      <CheckInternetModal
        isOpen={internetCheck}
        onClose={() => {
          setInternetCheck(false);
          setShowShimmer(false);
        }}
      />
      <ScenarioBasedBottomModal
        id="bd-modal"
        confetti_className="conatiner js-container"
        isOpen={showBottomModal}
        showCloseButton={false}
        showConfettiEffect={true}
        closeButtonStyle={{ backgroundColor: "transparent" }}
        onClose={() => {
          // // console.log("Closing Bottom Modal");
          // setNoOffer(false);
          setShowBottomModal(false);
          // navigate("/reference", {
          //   replace: true,
          // });
        }}
        modalMessageHeading={`Congratulations ${customerDetails?.Data?.first_name}!`}
        modalMessageHeadingStyle={{ color: "black" }}
        modalMessage={
          customerDetails?.source === "upsell"
            ? "You are eligible for an Top-Up loan of up to"
            : "You are eligible for an Instant loan of up to"
        }
        modalMessageStyle={{ color: "#747474" }}
        modalMessage2={"₹" + approvedLoanAmount.toLocaleString("en-IN")}
        modalMessage2Style={{
          color: "#CB3443",
          fontWeight: "bold",
          fontSize: "30px",
        }}
        modalSubmitMessage="OK"
        modalStyle={{
          borderRadius: "0px",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          margin: "0px",
          height: "30%",
        }}
        style={{ alignItems: "flex-end" }}
        onModalSubmit={() => {
          // // console.log("Closing Bottom Modal");
          // setNoOffer(false);
          setShowBottomModal(false);
          // navigate("/reference", {
          //   replace: true,
          // });
        }}
      />
      <ProgressBar showProgress={true} currentStep={3} />
      <LoanIPOWrapper className="first-child">
        <div className="progress-bar-container"></div>
        <div id="login-form">
          <div className="lipo-headings">
            <ShimmerPlaceholder
              height="2em"
              marginTop="1em"
              width="10em"
              visible={showShimmer}
            />
            <Title
              text={
                customerDetails?.Data?.first_name +
                " " +
                customerDetails?.Data?.last_name
              }
              visible={!showShimmer}
              clickable={false}
              style={{ fontSize: "20px" }}
            />
            <ShimmerPlaceholder
              height="3em"
              width="20em"
              marginTop="-0.5em"
              visible={showShimmer}
            />
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={`Your ${
                customerDetails.source === "upsell" ? "top-up" : "personal"
              } loan of ₹${approvedLoanAmount.toLocaleString(
                "en-IN"
              )} is ready to be availed!`}
              visible={!showShimmer}
              clickable={false}
              style={{
                fontSize: "16px",
                maxWidth: "60%",
              }}
            />

            <div
              style={{
                width: "110%",
              }}
            >
              {showShimmer ? (
                <>
                  <ShimmerPlaceholder height="2em" visible={showShimmer} />
                </>
              ) : (
                <>
                  <div className="heading-line">Customise your Loan</div>
                </>
              )}
            </div>

            <div className="range-selector-container">
              {showShimmer ? (
                <>
                  <ShimmerPlaceholder height="5em" visible={showShimmer} />
                </>
              ) : (
                <>
                  <div className="range-selector-container-1">
                    <div>Select your Loan amount</div>
                    <div className="display-amount">
                      {/* ₹{" "}
                      {selectedLoanAmount.toLocaleString(
                        "en-IN"
                      )} */}
                      ₹&nbsp;
                      <span
                        id="editableContent"
                        contentEditable={true}
                        suppressContentEditableWarning={true}
                        onInput={inputLoanAmount}
                      >
                        {parseInt(editableContent).toLocaleString("en-IN")}
                      </span>
                    </div>
                  </div>
                  <input
                    onChange={handleLoanAmountChange}
                    type="range"
                    value={selectedLoanAmount}
                    min={minTopUpAmount}
                    max={maxTopUpAmount}
                    step="1000"
                    id="selectedAmountRange"
                    className="slider-input"
                  />
                  <div className="slider-input-amount-min-max">
                    <div>₹ {minTopUpAmount.toLocaleString("en-IN")}</div>
                    <div>₹ {maxTopUpAmount.toLocaleString("en-IN")}</div>
                  </div>
                </>
              )}
              {showShimmer ? (
                <>
                  <ShimmerPlaceholder marginTop="0.5em" visible={showShimmer} />
                </>
              ) : (
                <>
                  <div className="tenure">
                    <div className="tenure-text">
                      <div className="tenure-text-1">Loan Tenure</div>
                      <div className="tenure-text-2">(in months)</div>
                    </div>
                    <div className="display-months">
                      {tenureOptions.map((ten, index) => {
                        return (
                          <div
                            key={index}
                            className="display-months-block"
                            style={{
                              backgroundColor:
                                tenure == ten ? "#CB3443" : "#FFFFFF",
                              color: tenure == ten ? "#FFFFFF" : "#494949",
                              borderColor: tenure == ten ? "none" : "#E7E7E7",
                            }}
                          >
                            <input
                              type="radio"
                              id={`tenure${ten}`}
                              name="customRadio"
                              value={ten}
                              onChange={handleTenureChange}
                            />
                            <label htmlFor={`tenure${ten}`}>{ten}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {showShimmer ? (
            <>
              <ShimmerPlaceholder
                height="13em"
                width="90%"
                visible={showShimmer}
              />
            </>
          ) : (
            <>
              <div className="summary-container">
                <div className="summary-box">
                  <div className="summaryBox-inside">
                    <Text
                      text="Loan Summary"
                      id="lsp-summary-title"
                      size="h5"
                    />
                    {customerDetails.source === "upsell" ? (
                      <div id="lsp-approved-summary-detail">
                        <LoanSummaryTextItem
                          title={"Existing Loan Balance"}
                          value={appendRupee(existingLoanBalance)}
                        />
                        <LoanSummaryTextItem
                          title={"Top up Loan Amount"}
                          value={appendRupee(selectedLoanAmount)}
                        />
                        <LoanSummaryTextItem
                          title={"Total Loan Amount"}
                          value={appendRupee(
                            selectedLoanAmount + existingLoanBalance
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"New Monthly EMI Amount"}
                          value={appendRupee(emi)}
                        />
                        <LoanSummaryTextItem
                          title={"Processing Fees"}
                          value={appendRupee(processingFees)}
                        />
                        <LoanSummaryTextItem
                          title={"Application no."}
                          value={applicationFormNumber}
                        />
                        <LoanSummaryTextItem
                          title={"Current Loan A/c No."}
                          value={oldLoanAccountNumber}
                        />
                        {/* <LoanSummaryTextItem
                    title={"Insurance Amount"}
                    value={appendRupee(
                      insuranceAmount
                    )}
                  /> */}
                        <LoanSummaryTextItem
                          title={"New Loan Tenure"}
                          value={`${tenure} Months`}
                        />
                        <LoanSummaryTextItem
                          title={"New Interest Rate"}
                          value={`${approvedRoi}%`}
                        />
                      </div>
                    ) : (
                      <div id="lsp-approved-summary-detail">
                        <LoanSummaryTextItem
                          title={"Loan Amount"}
                          value={appendRupee(selectedLoanAmount)}
                        />
                        <LoanSummaryTextItem
                          title={"EMI Amount"}
                          value={appendRupee(emi)}
                        />
                        <LoanSummaryTextItem
                          title={"Processing Fees"}
                          value={appendRupee(processingFees)}
                        />
                        <LoanSummaryTextItem
                          title={"Application no."}
                          value={applicationFormNumber}
                        />
                        {/* <LoanSummaryTextItem
                  title={"Insurance Amount"}
                  value={appendRupee(
                    insuranceAmount
                  )}
                /> */}
                        <LoanSummaryTextItem
                          title={"Loan Tenure"}
                          value={`${tenure} Months`}
                        />
                        <LoanSummaryTextItem
                          title={"Interest Rate"}
                          value={`${approvedRoi}% p.a.`}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="view-text ">
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  height="2em"
                  width="15em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                <div>
                  View{"  "}
                  <button
                    className="download-text"
                    onClick={() => {
                      setShowFeeAndChargesModal(true);
                    }}
                  >
                    Fees & Charges Details
                  </button>
                </div>
              </>
            )}
          </div>
          {/* {customerDetails?.stage === "IPO_START" &&
            customerDetails?.Data?.employment_type?.toUpperCase() ===
            "SALARIED" &&
            ["A", "B", "C", "D", "ABG"].includes(
              customerDetails?.Data?.employer_cat?.toUpperCase()
            ) &&
            customerDetails?.Data?.requiredHigherLoanAmount?.toUpperCase() !==
            "TRUE" && customerDetails?.Data?.journey_type !== "preapproved" &&
            customerDetails?.Data?.company_category_new?.toUpperCase() !==
              "NC" &&
            (customerDetails?.Data?.epfo_check !== "False" ||
              customerDetails?.Data?.otp_verify_required !== "False" ||
              customerDetails?.Data?.domain_and_email_check !== "False") && ( */}
          {customerDetails?.stage === "IPO_START" &&
            customerDetails?.Data?.employment_type?.toUpperCase() === "SALARIED" &&
            customerDetails?.Data?.requiredHigherLoanAmount?.toUpperCase() !== "TRUE" && (
              <div className="range-selector-container">
                {!showShimmer ? (
                  <div className="additional-details-card">
                    <div className="additional-confirm">
                      <div className="sub-title">
                        <SubTitle
                          text="Need loan of higher amount?"
                          style={{
                            textAlign: "left",
                            padding: "0px",
                          }}
                        />
                      </div>
                      <div className="radio-buttons">
                        <input
                          type="radio"
                          id="radio-btn-yes"
                          name="radio-btn"
                          checked={requiredHigherLoanAmount}
                          className="higherAmountRadio"
                          value={"Yes"}
                          onChange={updateRequiredHigherLoanAmount}
                        />
                        <label for="radio-btn-yes" className="radio-label">
                          Yes
                        </label>
                        <input
                          type="radio"
                          id="radio-btn-no"
                          name="radio-btn"
                          checked={!requiredHigherLoanAmount}
                          value={"No"}
                          className="higherAmountRadio"
                          onChange={updateRequiredHigherLoanAmount}
                        />
                        <label for="radio-btn-no" className="radio-label">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <ShimmerPlaceholder
                      visible={showShimmer}
                      height="50px"
                      marginTop="0.5em"
                    />
                  </>
                )}
              </div>
            )}
          <Modal
            open={showFeeAndChargesModal}
            showCloseButton={false}
            closeonClickOutside={true}
            onClose={() => {
              setShowFeeAndChargesModal(false);
            }}
            id="bd-email-otp-parent"
            className="termsAndConditions"
          >
            <div className="modal-dialog">
              <div
                className="modal-body"
                style={{
                  border: "1px solid #A7A7A7",
                }}
              >
                {/* <div className="pupup-inner">
                    <div className="title text-center">
                      <p className="fs-20 font-weight-medium text-black mb-4 pb-2 lh-1">
                        Content Coming Soon
                      </p>
                    </div>
                  </div> */}
                <table>
                  <thead>
                    <tr>
                    <td className="bold-td">Penal Charge</td>
                      <td>36% p.a. on overdue amount</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="bold-td">
                        Instrument Return Charges(Bounce Charges)
                      </td>
                      <td>Rs. 500</td>
                    </tr>
                    {customerDetails.source === "upsell" ? (
                      <tr>
                        <td className="bold-td">Pre-payment Charges</td>
                        <td>
                          <span style={{ fontWeight: "600" }}>Charges:</span>
                          <br />
                          1. NIL Charges - if part of pre-payment is equal to
                          20% of total disbursed amount in a year
                          <br />
                          2. 4% + GST, on remaining loan amount - if part
                          pre-payment is greater than 20%
                          <br />
                          <span style={{ fontWeight: "600" }}>Conditions:</span>
                          <br />
                          1. No pre-payment is allowed in first 12 months from
                          the date of disbursement
                          <br />
                          2. Part pre-payment amount should be equal to OR
                          greater than total of 3 EMIs
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td className="bold-td">Part Pre-payment charges</td>
                        <td>
                          <span style={{ fontWeight: "600" }}>Charges:</span>
                          <br />
                          NIL
                          <br />
                          <span style={{ fontWeight: "600" }}>Conditions:</span>
                          <br />
                            Pre-Payment is allowed only after 12
                            months from the date of Loan disbursal
                          <br />
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td className="bold-td">Foreclosure Charges</td>
                      <td>
                        <span style={{ fontWeight: "600" }}>Charges:</span>
                        <br />
                        4 % of the principal outstanding amount for term loan +
                        GST
                        <br />
                        <span style={{ fontWeight: "600" }}>Conditions:</span>
                        <br /> Foreclosure is allowed only after 12 months from
                        the date of Loan disbursal.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal>
          <div className="divBottom">
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  height="3em"
                  marginTop="-1em"
                  width="25em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="2.5em"
                  width="9em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                <CheckField
                  id="la-checkfield"
                  checked={ischecked}
                  label="By proceeding, I agree to Aditya Birla Capital Limited's offer."
                  style={{
                    marginLeft: "30px",
                    marginRight: "30px",
                    fontSize: "16px",
                    textAlign: "start",
                  }}
                  onClick={() => {
                    handleCheckBox();
                  }}
                />
                <Button
                  id="Btn"
                  className="Btn"
                  mobile={isMobile}
                  disabled={!ischecked}
                  onClick={
                    // onProceed
                    handleProceedClick
                  }
                  text={"Proceed"}
                />
              </>
            )}
          </div>
        </div>
      </LoanIPOWrapper>
    </>
  );
};

export default LoanIPO;
